import './scss/main.scss'

import { createApp, watchEffect, watch } from 'vue'
import App from './App.vue'
import i18n from './i18n'
import { createVuestic } from 'vuestic-ui'
import { useErrorStore } from './stores/errorStore'
import { useAuth } from './composables/useAuth'
import { useToast } from 'vuestic-ui'

import stores from './stores'
import router from './router'
import vuesticGlobalConfig from './services/vuestic-ui/global-config'

const app = createApp(App)
const { init: notify } = useToast()

app.use(stores)
app.use(router)
app.use(i18n)
app.use(createVuestic({ config: vuesticGlobalConfig }))
const errorStore = useErrorStore()

watchEffect(() => {
  if (errorStore.messages.length > 0) {
    notify({
      message: errorStore.messages.join(', '),
      color: 'danger',
    })
    errorStore.clearErrors()
  }
})

// Vue component errors
app.config.errorHandler = (err, instance, info) => {
  errorStore.setErrors([`[Vue] ${err instanceof Error ? err.message : String(err)} (${info})`])
}

const auth = useAuth()
watch(auth.isAuthenticated, (isAuthenticated) => {
  if (!isAuthenticated && router.currentRoute.value.name !== 'login') {
    router.push({ name: 'login' })
  }
})

app.mount('#app')

import('./composables/useTaskChecker').then(({ useTaskChecker }) => {
  useTaskChecker(10_000)
})
